export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/2c4738004d9e-tooliconboxquestion.jpg',
  },
  title: 'What item did you order?',
  placeholderText: 'e.g. TV, book',
}
